const prefix = actor => `srm-view:${encodeURIComponent(actor)}:`;
export function readViewPreference(actor, name, fallback) {
  if (actor == null) return fallback;
  try { const value = localStorage.getItem(prefix(actor) + name); return value == null ? fallback : JSON.parse(value); } catch (_) { return fallback; }
}
export function saveViewPreference(actor, name, value) {
  if (actor == null) return;
  try { localStorage.setItem(prefix(actor) + name, JSON.stringify(value)); } catch (_) { /* Local preferences never block interaction. */ }
}
export function clearViewPreferences(actor) {
  if (actor == null) return;
  try { Object.keys(localStorage).filter(key => key.startsWith(prefix(actor)) || key.startsWith(`uzdpart360:chat-draft:${encodeURIComponent(actor)}:`)).forEach(key => localStorage.removeItem(key)); } catch (_) { }
}
export function restoredBoardDates(saved, today) {
  if (!Array.isArray(saved) || saved.length !== 2 || saved.some(value => !/^\d{4}-\d{2}-\d{2}$/.test(value)) || saved[1] < today || saved[0] > saved[1] || saved.some(value => { const date = new Date(value); return !Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value; })) return [today, today];
  return saved;
}
